(function () {
    'use strict';
    angular.module('swif.interventions')
    .directive('panelPunch', panelPunch);

    panelPunch.$inject = ['swifPanelService'];
    function panelPunch(panel) {
        var directive = panel.create_directive('punch', {
            fields: ['user_id', 'type', 'time']
        });
        directive.templateUrl = 'partials/openstc/panel-punch.html';
        return directive;
    }
})();
